// components
import { Button } from "antd";

// styles
import styles from "components/molecules/Dialog/confirmDialog.module.css";
import getIcon from "utils/getIcon";
import theme from "styles/theme";

type DialogProps = {
	title?: string;
	subtitle?: string;
	actionButton?: {
		label: string;
		onClick?: () => void;
	};
	confirmButton?: {
		label: string;
		onClick?: () => void;
	};
	description?: string;
	cancelButton?: {
		label: string;
		onClick?: () => void;
		classes?: {
			label?: string;
			buttonInput?: string;
		};
	};
	linkButton?: {
		label: string;
		onClick?: () => void;
	};
	destroy?: () => void;
};

const ConfirmDialog = ({ title, subtitle, actionButton, confirmButton, cancelButton, linkButton, description, destroy }: DialogProps) => {
	const handleBack = () => {
		// Complete action before destroying the modal
		if (cancelButton?.onClick) {
			cancelButton?.onClick();
		}
		if (destroy) {
			destroy();
		}
	};

	const handleAction = () => {
		// Complete action before destroying the modal
		if (actionButton?.onClick) {
			actionButton?.onClick();
		}
		if (destroy) {
			destroy();
		}
	};

	const handleConfirm = () => {
		// Complete action before destroying the modal
		if (confirmButton?.onClick) {
			confirmButton?.onClick();
		}
		if (destroy) {
			destroy();
		}
	};

	const handleLinkButton = () => {
		if (linkButton?.onClick) {
			linkButton.onClick();
		}
		if (destroy) {
			destroy();
		}
	};
	const cancelButtonClasses = cancelButton && cancelButton.classes ? styles[`${cancelButton.classes.buttonInput}`] : styles?.back_button;
	return (
		<div className={styles?.root}>
			<div className={styles?.content_wrapper}>
				<div>{getIcon({ icon: "confirmDialog" })}</div>
				{title && <h1 className={styles?.title}>{title}</h1>}
				{description && (
					<div className={styles?.approvalText}>
						<span className="ml-2 mt-2">{description}</span>
					</div>
				)}
				{subtitle && <span className="text-center mt-[10px] mr-8 md:mr-0">{subtitle}</span>}
				<div className={styles?.action_buttons_wrapper}>
					{actionButton && (
						<Button type="primary" danger className={styles?.button} onClick={handleAction}>
							<span className={styles?.button_label}>{actionButton.label}</span>
						</Button>
					)}
					{confirmButton && (
						<Button className={`${styles?.button} confirmButton`} onClick={handleConfirm}>
							<span className={styles?.button_label}>{confirmButton.label}</span>
						</Button>
					)}

					{cancelButton && (
						<Button danger className={`${styles?.button} ${cancelButtonClasses}`} onClick={handleBack}>
							<span className={!cancelButton.classes ? styles?.back_button_label : styles[`${cancelButton.classes.label}`]}>{cancelButton?.label}</span>
						</Button>
					)}
				</div>
				{linkButton && (
					<Button className={styles?.inWindowText} type="link" onClick={handleLinkButton}>
						<p className="text-[#63267B]">{linkButton?.label}</p>
						<span>{getIcon({ icon: "inWindow", iconColor: theme.colors.violet })}</span>
					</Button>
				)}
			</div>
		</div>
	);
};

export default ConfirmDialog;
